import { Spinner } from '@frontend/components/common';

import { welcome } from '../../utils/kiosk-messages';
import LicenseNavigationCard from '../license-navigation-card/license-navigation-card.component';
import SignInCta from '../sign-in-cta/sign-in-cta.component';
import { useDefaultHome } from './default-home.controller';

export const DefaultHome = () => {
    const viewProps = useDefaultHome();

    return (
        <div className='flex size-full flex-col gap-4 overflow-hidden'>
            {viewProps.isLoading ? (
                <div className='col-span-2 flex flex-row justify-center'>
                    <Spinner />
                </div>
            ) : (
                <div className='flex size-full flex-col justify-between'>
                    <div className='flex min-h-0 flex-1 flex-col gap-4'>
                        <p className='text-background-surface shrink-0 text-sm font-semibold'>
                            {welcome()} {viewProps.display}
                        </p>
                        <div className='overflow-y-auto'>
                            <div className='grid w-full grid-cols-2 gap-3'>
                                {viewProps.functionalities
                                    .filter((functionality) => !functionality.hidden)
                                    .map((func) => (
                                        <LicenseNavigationCard
                                            key={func.id}
                                            functionality={func}
                                        />
                                    ))}
                            </div>
                        </div>
                    </div>
                    {viewProps.allowUserIdentification && !viewProps.isLoggedIn && (
                        <div className='flex w-full shrink-0 flex-col items-center justify-center pt-4 pb-12'>
                            <SignInCta iconSize='small' />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
